<template>
  <Content @back="handleBack">
    <!-- <template v-slot:nav_left>{{ recordInfo.recordName || '--' }}--取得成绩</template> -->
    <!-- <template v-slot:nav_right>
      <div  v-if="userRole === 'trainCamp' || userRole === 'youth' || userRole === 'club'"  class="yioks_btn" @click="addRecordSquad(recordUuid)">添加本赛事取得成绩</div>
      <div  v-if="userRole === 'system'"  class="yioks_btn" @click="addRecordSquadSystem(selectVal.organUuid,selectVal.youthUuid,recordUuid)">添加本赛事取得成绩</div>
    </template> -->
    <template v-slot:content_right>
      <div style="position:relative">
        <div class="select_wrap">
          <div class="select_box">
            <template v-if="userRole !== 'coach'">
              <select v-model="selectVal.organUuid" class="yioks_select" @change="changeOrg">
                <option value="" v-if="organList.length !== 1">全部区体育行政部门</option>
                <option
                  v-for="item in organList"
                  :key="item.organUuid"
                  :value="item.organUuid">{{ item.organShortName }}
                </option>
              </select>
              <select v-model="selectVal.youthUuid" class="yioks_select" @change="changeCenter">
                <option value="" v-if="centerList.length !== 1">全部培训机构</option>
                <option
                  v-for="item in centerList"
                  :key="item.uuid"
                  :value="item.uuid">{{ item.youthShortName }}
                </option>
              </select>
              <select
                v-model="selectVal.recordYear"
                class="yioks_select"
                @change="changeQuery(true)"
              >
                <option value="">全部年份</option>
                <option
                  v-for="(item, index) in yearList"
                  :key="index"
                  :value="item.value"
                >
                  {{ item.value }}
                </option>
              </select>
            </template>
            <template v-else>
              <select v-model="selectVal.youthUuid" class="yioks_select" @change="changeCoachCenter">
                <option value="">全部培训机构</option>
                <option
                  v-for="item in squadCoachList"
                  :key="item.key"
                  :value="item.value">{{ item.label }}
                </option>
              </select>
            </template>

            <!-- <select
              v-model="selectVal.auditState"
              class="yioks_select"
              @change="changeQuery(true)"
            >
              <option value="">审核状态</option>
              <option value="0">待审核</option>
              <option value="1">通过</option>
              <option value="2">驳回</option>
              <option value="3">拒绝</option>
            </select> -->

          </div>

          <!-- <div class="search_box">
            <input
              v-model.trim="selectVal.keyWord"
              type="text"
              class="yioks_input"
              placeholder="请输入关键词"
              @keyup.enter="changeQuery(true)"
            >
            <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
          </div> -->

        </div>
        <div style="position:absolute;top:73px;right:40px" v-if="selectVal.youthUuid && showList">
          已确认总分：{{totalScore}} 分
        </div>
      </div>


      <div class="list_wrap">
        <div v-if="showList" class="table">
          <div class="thead">
            <div class="tr">
              <div class="th seq"><strong>序号</strong></div>
              <div class="th youthShortName"><strong>机构简称</strong></div>

              <div class="th squadRanking"><strong>审核通过</strong></div>
              <div class="th squadRanking"><strong>审核不通过</strong></div>
              <div class="th squadRanking"><strong>审核驳回</strong></div>
              <div class="th squadRanking"><strong>待审核</strong></div>
              <div class="th squadRanking"><strong>提交总数</strong></div>
              <div class="th opt"><strong>操作</strong></div>
            </div>
          </div>
          <div class="scrollArea">
            <vue-scroll>
              <div class="tbodyWrap">
                <div class="tbody">
                  <div
                      v-for="(item, index) in recordYouthList"
                      :key="index"
                      class="tr">
                    <div class="td seq">
                      <p>{{ index + 1 }}</p>
                    </div>
                    <div class="td youthShortName" :title="item.youthShortName">
                      <p>{{ item.youthShortName || '--' }}</p>
                    </div>
                    <div class="td squadRanking">
                      <p>{{ item.auditSucceedNum}}</p>
                    </div>
                    <div class="td squadRanking">
                      <p>{{ item.auditRejectNum}}</p>
                    </div>
                    <div class="td squadRanking">
                      <p>{{ item.auditReturnNum}}</p>
                    </div>
                     <div class="td squadRanking">
                      <p>{{ item.auditAwaitNum}}</p>
                    </div>
                    <div class="td squadRanking">
                      <p>{{ item.submitNum}}</p>
                    </div>

                    <div class="td opt">
                      <p>
                        <span class="item" @click="viewRecordSquad(item.youthUuid,item.youthShortName,item.organUuid)">查看</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <yioks-loading v-if="loading"/>
        <template v-if="userRole === 'trainCamp' || userRole === 'youth' || userRole === 'club'">
          <yioks-empty v-if="empty" tips="暂时没有数据，" name="立即添加本赛事取得成绩" @callback="addRecordSquad(recordUuid)"></yioks-empty>
        </template>
        <template>
          <yioks-empty v-if="empty" tips="暂时没有数据"></yioks-empty>
        </template>
      </div>
      <Pagination :total="total" :page.sync="page"/>
      <yioks-tip :showTip="showTip" :tipMsg="'确定删除该比赛吗？'" @callback='isDelete'/>
    </template>

  </Content>
</template>

<script>

import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/regular/trash-alt'
import 'vue-awesome/icons/regular/edit'
import record from '@/api/record'
import storage from '@/utils/storage'
import squadFormRule from '@/utils/formRules/squad'
import {ops} from '@/utils/scrollIndialog'
import coach from '@/api/coach'
import squad from '@/api/squad'
import _ from "lodash";

export default {
  components: {
    'Content': () => import('@/components/layout/list'),
    'Pagination': () => import('@/components/Pagination'),
  },
  computed:{
    yearList() {
      let year = new Date().getFullYear()
      let yearList = []
      for (var i = 0; i <= (year - 2022); i++) {
        yearList.push({value: (2022 + i), label: (2022 + i)})
      }
      return yearList
    }
  },
  mixins: [squadFormRule],
  data() {
    return {
      ops,
      recordYouthList: [],
      recordInfo: {},
      userRole: storage.get('userInfo').userRole,
      uuid: storage.get('userInfo').uuid,
      recordUuid: this.$route.query.uuid,
      recordType: this.$route.query.recordType,
      totalScore : 0,
      total: 0,
      pageSize: 20,
      page: 0,
      empty: false,
      showList: false,
      showTip: false,
      loading: true,
      squadUuid: '',
      organName: '',
      organList: [],
      centerList: [],
      squadCoachList: [],
      selectVal: {
        uuid: '',
        keyWord: '',
        auditState: '',
        youthUuid: '',
        organUuid: '',
        recordYear: new Date().getFullYear()
      },
    }
  },
  watch: {
    page() {
      this.changeQuery()
    }
  },

  filters: {
    filterSex(val) {
      switch (val) {
        case 'male':
          return '男足'
        case 'female':
          return '女足'
        case 'mixed':
          return '联合组队'
        default:
          return '--'
      }
    },

    auditState(val) {
      let res = '';
      switch (val) {
        case 0:
          res = '待审核';
          break;
        case 1:
          res = '通过';
          break;
        case 2:
          res = '驳回';
          break;
        case 3:
          res = '拒绝';
          break;
        default:
          res = '--';
          break;
      }
      return res;
    },
  },
  created() {
    const {page, uuid, keyWord, auditState, organUuid, youthUuid,recordYear} = this.$route.query
    page && (this.page = Number(page));
    uuid && (this.$set(this.selectVal, 'uuid', uuid));
    keyWord && (this.$set(this.selectVal, 'keyWord', keyWord));
    auditState && (this.$set(this.selectVal, 'auditState', auditState));
    organUuid && this.$set(this.selectVal, "organUuid", organUuid);
    youthUuid && this.$set(this.selectVal, "youthUuid", youthUuid);
    recordYear && (this.$set(this.selectVal, 'recordYear', recordYear));

    // this.getRecordInfo() // 获取详情接口

    if (this.userRole !== 'coach') {
      this.getCenterList()
    } else {
      this.loadCoachCenterList();
    }
  },
  methods: {
    handleBack() {
      if(this.userRole === 'expert' || this.userRole === 'organ'){
        this.$router.push(this.$router.go(-1));
      }else{
        this.$router.push({
          path: "/record/list",
          query: {
            idx: 0,
          }
        });
      }
    },


    getCenterList() {
      let data = this.uuid
      let request = coach.getCenterListByYouth
      if (this.userRole === 'organ') {
        request = coach.getCenterListByOrgan
        // data = this.uuid
      } else if (this.userRole === 'system' || this.userRole === 'admin'  ||  this.userRole === 'expert') {
        request = coach.getCenterListBySystem
        data = ''
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = coach.getCenterListByYouth
      } else {
        request = coach.getCenterListByOther
        data = ''
      }
      request(data).then((res) => {
        this.organList = res
        if (this.selectVal.organUuid) {
          this.centerList = this.organList.find(item => {
            return item.organUuid === this.selectVal.organUuid
          }).youthList || []
        } else {
          if (this.organList.length === 1) {
            this.selectVal.organUuid = this.organList[0].organUuid
            this.centerList = this.organList[0].youthList || []
          }
        }
        if (this.centerList.length === 1) {
          if (!this.selectVal.youthUuid) {
            this.selectVal.youthUuid = this.centerList[0].uuid
          }
        }
        this.getRecordYouthList()
      })
    },

    changeOrg() {
      this.centerList = []
      this.$set(this.selectVal, 'youthUuid', '')
      if (this.selectVal.organUuid) {
        const {youthList} = this.organList.find(item => {
          return item.organUuid === this.selectVal.organUuid
        })
        this.centerList = youthList || []
        if (this.centerList.length === 1) {
          this.$set(this.selectVal, 'youthUuid', this.centerList[0].uuid)
        }
      }
      this.changeQuery(true)
    },
    changeCenter() {
      this.changeQuery(true)
    },
    changeCoachCenter() {
      this.changeQuery(true)
    },


    // 教练获取搜索项可选内容
    loadCoachCenterList() {
      const _ = require('lodash');
      squad.getSquadListCoachAllToCoach()
        .then(res => {
          if (res.code) {
            this.$message.error(res.msg)
            return
          }
          const uni_selectYouthList = _.unionBy(res, "youthUuid");
          this.squadCoachList = uni_selectYouthList.map((item) => ({
            label: `${item.organShortName} - ${item.youthShortName}`,
            value: item.youthUuid,
            key: JSON.stringify({squadUuid: item.squadUuid, youthUuid: item.youthUuid, organUuid: item.organUuid})
          }));
          this.getRecordYouthList()
        })
    },

    // 编辑详情接口
    getRecordInfo() {
      this.loading = true
      record.getRecordInfo(this.recordUuid).then(res => {
        if (res.code) {
          this.$message.error(res.msg)
        }
        this.recordInfo = res;
        this.loading = false;
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },

    // 获取列表
    getRecordYouthList() {
      this.loading = true
      this.empty = false
      this.showList = false

      record.getRecordYouthSummaryPageSystem({
        page: this.page,
        size: this.pageSize,
        recordUuid: this.recordUuid,
        squadName: this.selectVal.keyWord,
        auditState: this.selectVal.auditState,
        youthUuid: this.selectVal.youthUuid,
        organUuid: this.selectVal.organUuid,
        recordYear: this.selectVal.recordYear
      }).then((res) => {
        this.loading = false
        this.total = res.totalElements
        if (res.content.length) {
          this.recordYouthList = res.content
          let total = 0;
          if(this.selectVal.youthUuid){ // 只有筛选了机构了 再去算总分吧
            this.recordYouthList.map(item=>{
              if(item.auditState === 1) {
                total = total + item.squadScore;
              }
            })
          }
          this.totalScore = total;
          this.showList = true
        } else {
          this.empty = true
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },
    deleteRecord(uuid) {
      this.showTip = true
      this.squadUuid = uuid
    },
    isDelete(isSure) {
      if (isSure) {
        record.deleteRecordYouthToSquad(this.squadUuid).then(res => {
          this.showTip = false
          this.getRecordYouthList()
        })
      } else {
        this.showTip = false
      }
    },
    goDetail(uuid) {
      this.$router.push({
        path: 'detail',
        query: {
          uuid
        }
      })
    },

    // 比赛
    addRecordSquad(recordUuid) {
      this.$router.push({
        path: 'addRecordYouthToSquad',
        query: {
          recordUuid,
        }
      })
    },
    addRecordSquadSystem(organUuid,youthUuid,recordUuid) {
      if (!organUuid || !youthUuid || !recordUuid){
        this.$message.error("请选择机构！");
        return;
      }
      this.$router.push({
        path: 'addRecordYouthToSquad',
        query: {
          organUuid,
          youthUuid,
          recordUuid
        }
      })
    },
    eidtRecordSquad(recordUuid, uuid) {
      this.$router.push({
        path: 'addRecordYouthToSquad',
        query: {
          type: 'edit',
          recordUuid,
          uuid,
        }
      })
    },
    viewRecordSquad(uuid,name,organUuid) {
      this.$router.push({
        path: 'youthSs',
        query: {
          youthUuid:uuid,
          youthShortName: name,
          organUuid: organUuid,
          recordYear: this.selectVal.recordYear
        }
      })
    },

    auditRecordSquad(recordUuid, uuid) {
      this.$router.push({
        path: 'addRecordYouthToSquad',
        query: {
          type: 'audit',
          recordUuid,
          uuid,
        }
      })
    },

    // 搜索
    changeQuery(flag) {
      if (flag) this.page = 0
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: this.page,
          uuid:this.selectVal.uuid,
          keyWord: this.selectVal.keyWord,
          auditState: this.selectVal.auditState,
          youthUuid: this.selectVal.youthUuid,
          organUuid: this.selectVal.organUuid,
          recordYear: this.selectVal.recordYear,
        }
      })
      this.getRecordYouthList()
    },
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.listBox{
  ::v-deep > .nav{
    display none !important
  }
  ::v-deep .contentMain{
    background transparent !important
  }
}
.list_wrap
  flex 1
  overflow hidden

  .table {
    display flex
    flex-direction column
    flex 1
    width: 100%;

    .thead, .tbody {
      border: 1px solid $color_white;
    }

    .thead {
      margin: 0 40px;

      .tr {
        height: 45px;
        display: flex;
      }
    }

    .scrollArea {
      height: 425px;
      padding-bottom 15px
      /*flex 1 */
      /*overflow hidden*/
    }

    .tbodyWrap {
      display block
      // padding: 0 40px;
    }

    .tbody {
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width: 810px;
      border-top: none;
      border-bottom: none;

      .tr {
        height: 49px;
        display: flex;
        border-bottom: 1px solid $color_white;
      }
    }

    .th, .td {
      height: 100%;
      /*flex: 1 1 auto;*/
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: $font_size_medium;
      border-right: 1px solid $color_white;
    }

    .th:last-child, .td:last-child {
      border-right: none;
    }

    .td {
      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: $color_white;
      }
    }

    .seq {
      width 7%
    }

    .youthShortName {
      width 29%
    }

    .squadNameSystem {
      width 20%
    }

    .squadName {
      width 41%
    }

    .squadRanking {
      width 12%
    }

    .squadScore {
      width 12%
    }

    .auditState {
      width: 12%;
    }

    .opt {
      width: 16%;

      p {
        width 100%
        text-align center

        .item {
          cursor: pointer;
          user-select: none;
          color $green_color
        }

        .split {
          margin 0 5px
        }
      }
    }
  }

.demo-ruleForm
  height 475px

.tip
  margin-top 10px
  color red
  width 100%
  text-align center
  word-break break-word

.nav_wrap {
  display: flex;
  justify-content: space-between;
  font-size: 16px;

  .nav_list {
    display: flex;

    .nav_item {
      cursor: pointer;
      user-select: none;
      padding: 10px 15px;

      &.active {
        background: $green_color;
      }
    }
  }
}
</style>

